import { render, staticRenderFns } from "./addQuality.vue?vue&type=template&id=b2af827a&scoped=true&"
import script from "./addQuality.vue?vue&type=script&lang=js&"
export * from "./addQuality.vue?vue&type=script&lang=js&"
import style0 from "./addQuality.vue?vue&type=style&index=0&id=b2af827a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2af827a",
  null
  
)

export default component.exports